import React from "react";

import Checkbox from "ui/atoms/Checkbox";

interface TableSelectAllProps {
  allRows: { id: string }[] | undefined;
  selectedRowIds: string[];
  setSelectedRowIds: React.Dispatch<React.SetStateAction<string[]>>;
  onSetSelectedRowIdsCallback?: () => void;
  checked: boolean;
}

const TableSelectAll: React.FC<TableSelectAllProps> = ({
  allRows,
  selectedRowIds,
  setSelectedRowIds,
  onSetSelectedRowIdsCallback,
  checked,
}) => {
  const handleSelectAll = (): void => {
    if (!allRows || allRows.length === 0) {
      return;
    }

    if (allRows.length !== selectedRowIds.length) {
      const allRowIds: string[] = allRows.map((row) => row.id);
      setSelectedRowIds(allRowIds);
    } else {
      setSelectedRowIds([]);
    }

    if (onSetSelectedRowIdsCallback) {
      onSetSelectedRowIdsCallback();
    }
  };

  return <Checkbox onChange={handleSelectAll} checked={checked} />;
};

export default TableSelectAll;
